import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { GetUrunFiyatFarkiRequest, GetUrunFiyatFarkiResponse } from '../models/model'

export class GetUrunFiyatFarkiApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'VodafoneReports/GetVodafoneUrunFiyatFarki',
      requesterInfo,
    })
  }

  public async getList(request: GetUrunFiyatFarkiRequest): Promise<GetUrunFiyatFarkiResponse[]> {
    return await this.postAsync<GetUrunFiyatFarkiResponse[]>(request)
  }
}
